module.exports = __webpack_public_path__ + "3d0114dab6beefd8889ca6ae2aff8f55.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/mobile_shop.mp4
// module id = 230
// module chunks = 0